import { render, staticRenderFns } from "./Degustacao.vue?vue&type=template&id=6dab7f7b&"
import script from "./Degustacao.vue?vue&type=script&lang=js&"
export * from "./Degustacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports